var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-calendar',{attrs:{"is-inline":"","is-double-paned":"","is-linked":"","is-expanded":"","mode":"multiple","show-day-popover":false,"attributes":_vm.attrs,"formats":_vm.formats},on:{"dayclick":_vm.dayClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }